import React, {
  useEffect,
  useRef,
  MutableRefObject,
  FunctionComponent,
  ReactElement,
  ReactNode,
} from "react";

import "./index.scss";

type TabPanelProps = {
  i: any;
  value: any;
  children?: ReactNode | ReactNode[];
  navigateTo?: boolean;
  key: string;
};

export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  i,
  navigateTo,
  key,
}) => {
  const itemRef = useRef() as MutableRefObject<HTMLDivElement>;

  useEffect(() => {
    if (itemRef && itemRef.current && navigateTo) {
      itemRef.current.scrollIntoView({ behavior: "smooth" });
    }
  });

  const updateWithprops = React.Children.map(children, (child, i) => {
    return React.cloneElement(child as ReactElement | any, {
      value,
      i,
      key,
    });
  });

  return (
    <div
      role="tabpanel"
      className="section--tab-panel"
      id={`simple-tabpanel-${i}`}
      aria-labelledby={`scrollable-auto-tab-${i}`}
      ref={value === i ? itemRef : null}
    >
      {updateWithprops}
    </div>
  );
};

// React.cloneElement(child, { value })

export default TabPanel;
